interface CustomWindow extends Window {
  Beacon?: (cmd: string, args?: any) => void;
  beaconOpen?: boolean;
}

const customWindow = window as CustomWindow;

export default customWindow;
